import { RootState } from 'shared/types/store'

import { initialState } from './slice'

const getLiveMatchBroadcastContainer = (state: RootState) =>
  state.liveMatchBroadcastContainer ?? initialState

export const selectCurrentBroadcast = (state: RootState) =>
  getLiveMatchBroadcastContainer(state).currentBroadcast
